import QuestionsIconSolidDuotone from '@/components/icons/QuestionsIconSolidDuotone';
import { t } from 'i18next';

const FaqPageEmpty = () => {
	return (
		<div className='h-full flex flex-col items-center justify-center gap-2'>
			<QuestionsIconSolidDuotone className='size-8' />
			<div className='w-80 flex flex-col gap-1 text-center'>
				<h3 className='text-lg font-medium'>
					{t('main.faq.components.pageEmpty.title')}
				</h3>
				<p className='text-sm text-popover-800'>
					{t('main.faq.components.pageEmpty.description')}
				</p>
			</div>
		</div>
	);
};

export default FaqPageEmpty;
